const norm = (s) => String(s || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase();

/** Shampoo range is automatic: any single product whose name contains "shampoing". */
export const isShampooRange = (p) => p?.type === "unite" && norm(p.name).includes("shampoing");
export const isConditioner = (p) => /apres[-\s]?shampoing/.test(norm(p?.name));

const NEED_BY_CATEGORY = { Pousse: "Pousse & cuir chevelu", Locks: "Locks", Barbe: "Barbe", Kids: "Famille & junior", "Visage & Corps": "Visage & corps", "Soins visage": "Visage & corps", "Soins du corps": "Visage & corps" };
export const shampooNeed = (p) => (norm(p.name).includes("pellicul") ? "Anti-pellicules" : NEED_BY_CATEGORY[p.category] || p.category);
